import request from "@/utils/request";

export function login(data) {
  return request({
    url: "admin/login",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 获取验证码
export function getCaptchaImage() {
  return request({
    url: "/captchaImage",
    method: "get",
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "admin/getInfo",
    method: "get",
  });
}
// 退出方法
export function logout() {
  return request({
    url: "admin/logout",
    method: "post",
  });
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: "admin/updatePassword",
    method: "put",
    data,
  });
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: "admin/resetPassword",
    method: "post",
    data,
  });
}
